import {
	IconAssignmentFilled,
	IconFavoriteFilled,
	IconViewFilled,
} from '@featuring-corp/icons';
import React from 'react';
import CardGroupSection, {
	CardGroupItem,
} from '@components/report/card-group-section/CardGroupSection';

export interface KeyMetricsNbProps {
	averageDailyVisitors?: string;
	averageTotalVisitors?: string;
	postAverageViews?: string;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const KeyMetricsNb = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: KeyMetricsNbProps) => {
	const status = { isLoading, isError, lackOfPermission };

	const cardGroup: CardGroupItem[] = [
		{
			label: '평균 일 방문자 수',
			tooltip: '최근 10개의 콘텐츠를 기준으로 계산된 평균 일 방문자 수입니다. ',
			icon: IconFavoriteFilled,
			content: props.averageDailyVisitors,
		},
		{
			label: '누적 방문자 수',
			tooltip: '블로그 개설 이후 현재까지의 총 방문자 수를 나타냅니다.',
			icon: IconViewFilled,
			content: props.averageTotalVisitors,
		},
		{
			label: '게시글 일 평균 조회 수',
			tooltip: '최근 10개의 콘텐츠를 기준으로 계산된 게시글 일 평균 조회 수입니다.',
			icon: IconAssignmentFilled,
			content: props.postAverageViews,
		},
	];

	return <CardGroupSection cardGroup={cardGroup} {...status} />;
};

export default KeyMetricsNb;
